import { Params } from '@angular/router';
import { TransportKind, TransportSide } from '@/new-transport/_models/transport.model';

export enum TransportParamsOptions {
	KIND = 'kind',
	SIDE = 'side',
}

/**
 * Reads the transport side from URL parameters and validates its value.
 *
 * This function extracts the 'side' parameter from the given URL parameters and checks
 * if it matches one of the valid transport sides: `RETURN` or `DEPARTURE`.
 * If the 'side' parameter is invalid, an error is thrown.
 *
 * @param {Params} params - The URL parameters from which to extract the 'side'.
 * @param {TransportParamsOptions} property - Name of the params we want to find
 * @returns {TransportSide} - The validated transport side, either `RETURN` or `DEPARTURE`.
 * @throws {Error} - Throws an error if the 'side' parameter is invalid.
 */
export const readPropertyFromUrlParams = (
	params: Params,
	property: TransportParamsOptions,
): TransportSide | TransportKind => {
	switch (property) {
		case TransportParamsOptions.KIND:
			const kind = params['kind'];

			if (kind === undefined) {
				return;
			}

			if (![TransportKind.REAL, TransportKind.OFFER, TransportKind.TEMPLATE].includes(kind)) {
				throw new Error('Nieprawidłowy rodzaj transportu');
			}

			return kind;
		case TransportParamsOptions.SIDE:
			const side = params['side'];

			if (side !== TransportSide.RETURN && side !== TransportSide.DEPARTURE) {
				throw new Error('Nieprawidłowy kierunek');
			}

			return side;
		default:
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const value: never = property;
			throw new Error(`There is no value like: ${value}`);
	}
};
